<template>
  <div class='h-dialogContainer'>
    <div v-for='(set, index) in setting' :key='index' class='row h-row-inputBox'>
      <div class='col-sm-2 h-col-inputBox'>
        <div class='h-inputLit'>{{$t('Alarm.isOpen')}}:</div>
        <ejs-switch v-model='set.isAct' :checked='set.isAct'></ejs-switch>
      </div>
      <div class='col-sm-3 h-col-inputBox'>
        <div class='h-inputLit'>{{$t('Alarm.unclearedDuration')}}:</div>
        <div class='row'>
            <ejs-dropdownlist v-model="set.type" :fields='listFields' :dataSource='typeList' :placeholder='listPlaceholder' :change="changePeriod"></ejs-dropdownlist>
        </div>
      </div>
      <div class='col-sm-3 h-col-inputBox'>
        <div class='h-inputLit'>默认扫描周期:</div>
        <div class='row'>
            <input id='period' name='period' width='180px' disabled value='30s' />
        </div>
      </div>
    </div>
    <div class='h-clear-rowMg'></div>
  </div>
</template>
<script>
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'autoConfirmSetting',
  data() {
    return {
      listPlaceholder: this.$t('Alarm.pleaseChoose'),
      listFields: {
        text: 'name',
        value: 'code'
      },
      typeList: [
        { name: '5  '+this.$t('Alarm.minute'), code: 5 },
        { name: '10 '+this.$t('Alarm.minute'), code: 10 },
        { name: '30 '+this.$t('Alarm.minute'), code: 30 },
        { name: '1  '+this.$t('Alarm.hour'), code: 60 },
        { name: '5  '+this.$t('Alarm.hour'), code: 300 }
      ],
      setting: [{
        id: 1,
        type: 5,
        isAct: false
      }],
      originalSetting:[{}]
    };
  },
  methods: {
    getCommonSettingInfo() {
      this.$axios.post('/lte/ems/fm/setting/queryUpdateAlarm', {id: "1"}).then((response) => {
        //console.log("response.data.resultVal" + JSON.stringify(response.data.resultVal))
        if (response && response.status === 200) {
          const data = response.data.resultVal.commonSetting;
          this.setting[0].isAct = data.flag === 1;
          this.setting[0].type = Number(data.value);
        }
      });
    },
    changePeriod() {
      var value = this.setting[0].type;
      if(value <= 30){
        document.getElementById("period").value='30s'
      }else{
        document.getElementById("period").value='60s'
      }

    },
    getSettingData() {
      var param = {
        id: this.setting[0].id,
        value: this.setting[0].type + "",
        key: "updateAlarm",
        flag: this.setting[0].isAct ? 1 : 0
      };
      console.log(JSON.stringify(param))
      return JSON.stringify(param);
    }
  }
};
</script>
